module.exports = __webpack_public_path__ + "img/dixie-coop.b484a244.jpg";